export function mapItemsWithIcon<T extends { icon?: { type?: string } }>(
    items: T[]
): (Omit<T, "icon"> & { icon?: string })[] {
    return items?.map(({ icon, ...rest }) => ({
        ...rest,
        icon: icon?.type,
    }));
}
